// extracted by mini-css-extract-plugin
export default {"capsulecontainer":"CapsuleTable_capsulecontainer__W5cMC","disabled":"CapsuleTable_disabled__+i2wn","link":"CapsuleTable_link__QkneQ","btnC":"CapsuleTable_btnC__OHvDf"};